import React from 'react';
import { Image, Input } from 'antd';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

import { ISubQuestion } from 'modules/national-certificate';

import { MathJaxContext } from 'components';

interface IProps {
  test?: ISubQuestion[];
}

export const OptionsWithInput: React.FC<IProps> = ({ test }) => {
  const t = useTranslations();

  return (
    <div className={classNames('grid grid-cols-1 gap-1', (test?.length || 0) > 1 && 'md:grid-cols-2')}>
      {test?.map((option, index) => {
        const answer = option?.answer?.trim() || '';
        const correct = option.correct_text_answer?.trim() || '';

        const isCorrect = answer && answer === correct;
        const isWrong = answer && answer !== correct;

        return (
          <div key={option.id} className="rounded-xl border-2 border-transparent">
            <div className="flex h-full cursor-pointer flex-col  justify-between rounded-xl border border-gray-200 p-2.5 transition-all">
              <div className="mb-1 flex items-center gap-3">
                <span className="font-semibold text-gray-600">{String.fromCharCode(97 + index)})</span>

                <div className="min-w-0 flex-1 overflow-x-auto overflow-y-hidden">
                  <p className="inline-block whitespace-pre-line text-xs text-gray-800">
                    <MathJaxContext expression={option.question_name} />
                  </p>

                  {option?.image && (
                    <div className="mt-2 flex justify-center">
                      <Image src={option.image} alt={option.name || 'Test option'} loading="lazy" title="Test image" />
                    </div>
                  )}
                </div>
              </div>

              <Input
                className={classNames(
                  `!h-8.5 !rounded-lg !bg-gray-100 !text-sm hover:!border-gray-200 focus:!border-gray-200`,
                  {
                    '!border-green-500': isCorrect,
                    '!border-red-500': !isCorrect && isWrong,
                    "border-gray-200": !isCorrect && !isWrong
                  }
                )}
                placeholder={t('javobingizni_yozing')}
                value={answer}
                disabled
              />

              <p className="mt-1 text-xs font-medium text-green-500">{isCorrect ? t('togri_javob') : correct}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
